import React from 'react';
import { PURCHASES_STATUS } from '../../../../utils/constants/purchases-status';
import SelectCheckbox from '../../../../shared/select-checkbox';
import { ENABLED_FILTERS } from '../../../../utils/constants/enable-filter-values';


interface IPurchaseFilters {
    selectedStatus?: any;
    onClickFilter: (value: any, type?: string) => void;
}

const PurchaseFilters = ({
    selectedStatus,
    onClickFilter
}: IPurchaseFilters) => {
    return (
        <div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
                <SelectCheckbox
                    name='Invoiced'
                    dataQa={'status-filter'}
                    placeholder={''}
                    options={ENABLED_FILTERS || []}
                    selectStyle={{ backgroundColor: '#ffffffa4', borderRadius: '4px', minWidth: 200 }}
                    onChangeSelectedOption={onClickFilter}
                    selectedOption={selectedStatus}
                    uniqueName={'status'}
                />
            </div>
        </div>
    );
};

export default PurchaseFilters;
